import React from 'react';
import { useTranslation } from 'react-i18next';

import { LogoIcon } from 'src/components/icons';
import { TranslatedTextError } from '../TranslatedTextError';

type Props = {
  error: Error;
  retry?: () => void;
  testID?: string;
};

export const ErrorScreen: React.FC<Props> = ({ retry, error, testID = 'Loading' }) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center justify-center w-screen h-screen flex-col"
      style={{
        background: "url('/bg-track.png') center no-repeat",
      }}
    >
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br ">
        {/* Error Message */}

        <LogoIcon className="w-40 md:w-40 my-2 m-auto" />

        <div className="text-center">
          <TranslatedTextError message={error?.message ?? t('global.unknownError')} className="text-2xl" />
        </div>

        {/* Retry Button */}
        {retry && (
          <button
            onClick={retry}
            className="cursor-pointer mt-6 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg shadow-lg hover:bg-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none transform transition-transform duration-300 hover:scale-105"
          >
            {t('global.retry')}
          </button>
        )}
      </div>
    </div>
  );
};
